import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const PayrollCardHeader = ({ headerData }) => {
  return (
    <div className="d-flex p-3 w-100">
      {headerData.map((data) => {
        return (
          <div className={`${data.className} ft-12 fw-500 header-label-color`}>
            {data.label}
            {/* {data.icon && (
              <span>
                <FontAwesomeIcon
                  icon={data.icon}
                  className={"header-label-color ml-1"}
                  style={{ paddingTop: "2px" }}
                />
              </span>
            )} */}
          </div>
        );
      })}
    </div>
  );
};

export default PayrollCardHeader;
